import {
  USER_NOTIFICATION_TYPE_PARENT,
  USER_NOTIFICATION_TYPE_PARENT_UPDATE,
  USER_NOTIFICATION_TYPE_BUS,
  USER_NOTIFICATION_TYPE_CANCEL
} from '@/config'

export default {
  retrieveAdminNotificationList (state, payload) {
    state.adminNotificationList = [].concat(payload.notificationList)
  },

  updateParentHistoryState (state, payload) {
    state.currentParentHistoryFilter = payload.filter ? Object.assign({}, payload.filter) : null
    state.currentParentHistorySort = payload.sort ? Object.assign({}, payload.sort) : null
    state.currentParentHistoryPage = payload.page ? payload.page : null
  },

  updateParentNotificationState (state, payload) {
    state.currentParentNotificationFilter = payload.filter ? Object.assign({}, payload.filter) : null
    state.currentParentNotificationSort = payload.sort ? Object.assign({}, payload.sort) : null
    state.currentParentNotificationPage = payload.page ? payload.page : null
  },

  updateBusNotificationState (state, payload) {
    state.currentBusNotificationFilter = payload.filter ? Object.assign({}, payload.filter) : null
    state.currentBusNotificationSort = payload.sort ? Object.assign({}, payload.sort) : null
    state.currentBusNotificationPage = payload.page ? payload.page : null
  },

  updateAdminNotificationState (state, payload) {
    state.currentAdminNotificationPage = payload.page ? payload.page : null
  },

  retrieveCancelList (state, payload) {
    state.cancelList = [].concat(payload.cancelList)
  },

  updateCancelState (state, payload) {
    state.currentCancelFilter = payload.filter ? Object.assign({}, payload.filter) : null
    state.currentCancelSort = payload.sort ? Object.assign({}, payload.sort) : null
    state.currentCancelPage = payload.page ? payload.page : null
  },

  updateAuthorizedPersonState (state, payload) {
    state.authorizedPersonFilter = payload.filter ? Object.assign({}, payload.filter) : null
    state.authorizedPersonSort = payload.sort ? Object.assign({}, payload.sort) : null
    state.authorizedPersonPage = payload.page ? payload.page : null
  },
}
